import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Listloader from "../loader/content";

const ElementModal = (props) => {
  const [allElem, setallElem] = useState([]);

  useEffect(() => {
    if (props.elemid) {
      setallElem(props.elemid);
    }
  }, [props.elemid]);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.paged ? " Reference Pages" : " Reference Elements"}
        </Modal.Title>
      </Modal.Header>
      <span className="text-muted mt-2" style={{ paddingLeft: "1rem" }}>
        {allElem
          ? props.paged
            ? "This Element is referenced by following Pages.Unlink them before continuing delete."
            : "This Page is referenced by following Elements.Unlink them before continuing delete."
          : "Please Wait Checking if any reference exist for the selected Item."}
      </span>
      <Modal.Body>
        <Row>
          {allElem ? (
            allElem.map((item, index) => (
              <Col sm="6" key={index}>
                <Link
                  to={
                    !props.paged
                      ? item.elementType === "tabItem"
                        ? "/tab/" + item._id
                        : item.elementType === "textGrid"
                          ? "/textGrid/" + item._id
                          : item.elementType === "highlightTextGrid"
                            ? "/highlightTextGrid/" + item._id
                            : "/item/" + item.elementType + "/" + item._id
                      : item.pageType === "normalPage"
                        ? "/page/" + item._id
                        : "/" + item.pageType.toLowerCase() + "/" + item._id
                  }
                >
                  {item.referenceName}
                </Link>
              </Col>
            ))
          ) : (
            <Col sm="12" className="text-center">
              <Listloader></Listloader>
            </Col>
          )}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};
export default ElementModal;
